function sGCheckboxValidation(event, options) {
  /*Native Bootstrap 5 validation does not at the current moment support Siteglide checkboxes with multiple options. This JS function fixes that.*/
  
  if(event) {
    var form = event.currentTarget.closest('form');
  } else {
    var {form} = options;
  }
  
  var checkboxesNeedValidation = form.querySelectorAll('.required input[type=checkbox],.required input[type=radio]');
  var names = Array.from(checkboxesNeedValidation).map(
    function(item) {
      return item.getAttribute('name');
    }
  );
  names = names.filter(
    function(item,index) {
      return names.indexOf(item) === index;
    }
  );
  names.forEach(
    function(name) {
      var checkboxesWithName = form.querySelectorAll('[name='+name.replace(/\[/g, '\\[').replace(/\]/g, '\\]')+']');
      var checkboxesWithNameArray = Array.from(checkboxesWithName);
      var passesValidation = checkboxesWithNameArray.filter(
        function(item) {
          return item.checked;
        }
      );
      if(passesValidation.length > 0) {
        checkboxesWithName.forEach(
          function(item) {
            /* Note- checkboxes keep the class .required so that if the value is removed before the next validation, required attr can be added again. */
            item.removeAttribute('required');
          }
        )
      } else {
        checkboxesWithName.forEach(
          function(item) {
            item.setAttribute('required', '');
          }
        )
      }
    }
  )
}

window.sGCheckboxValidation = sGCheckboxValidation;